import React from 'react';
import { FormControl, InputLabel, Input, InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';

interface Props {
  value: string | undefined;
  onChange: (val: string) => void;
}

const SearchField: React.FunctionComponent<Props> = props => {
  return (
    <FormControl fullWidth style={{ marginBottom: '16px' }}>
      <InputLabel htmlFor="searchfield">Search</InputLabel>
      <Input
        id="searchfield"
        type="text"
        fullWidth
        value={props.value}
        onChange={event => {
          event.preventDefault();
          props.onChange(event.target.value);
        }}
        endAdornment={
          <InputAdornment position="end">
            <Search />
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default SearchField;
